export default __webpack_public_path__ + "book-up-885662c85e1a6b7e3b355a14ca8c2d59.svg";